import { createContext } from "react"

export type AgencySelectModalInterface = {
    query: (callback: (agencyID: string) => void) => void
}

export const AgencySelectModalContext = createContext<AgencySelectModalInterface | undefined>(undefined)